import React from 'react';
import { InputNumber } from 'antd';
import { ReactComponent as PlusPassenger } from '../../../../resources/images/svg/plusPassenger.svg';
import DefaultButton from '../../components/buttons/defaultButton/DefaultButton';
import useTranslation from '../../../hooks/translation/useTranslation';
import { useAuth } from '../../../contexts/userContext/userContext';

function AddPassengerInput({ watchValue, onChange }) {
  return (
    <InputNumber
      bordered={false}
      className="transparent-number-input"
      min={0}
      type="number"
      controls={false}
      onChange={(value) => onChange(value)}
      onBlur={() => {
        if (watchValue === '' || watchValue === null) {
          onChange(0);
        }
      }}
      value={watchValue}
    />
  );
}

function AddPassengersInputContent({
  standard, form, disabled, setOpen, closeBtn = false, child,
}) {
  const { user } = useAuth();
  const { trans } = useTranslation();

  const setChild = (value) => {
    if (standard + value + disabled > 9) {
      return;
    }
    form.setFieldValue('child_passengers', value);
  };
  const setStandard = (value) => {
    if (value + child + disabled > 9) {
      return;
    }
    if (disabled + value < 1) {
      setChild(0);
    }
    form.setFieldValue('standard_passengers', value);
  };
  const setDisabled = (value) => {
    if (standard + child + value > 9) {
      form.setFieldValue('disabled_passengers', disabled);
      return;
    }
    if (standard + value < 1) {
      setChild(0);
    }
    form.setFieldValue('disabled_passengers', value);
  };

  return (
    <div className="flex flex-col gap-4 customer-passenger-input">
      <div className="flex gap-[70px] justify-between items-center">
        <p className="m-0">{trans('standard')}</p>
        <div className="flex gap-3 items-center passenger-counter">
          <button type="button" className="bg-transparent border-0 p-0 flex">
            <PlusPassenger onClick={() => setStandard((standard - 1 >= 0 ? standard - 1 : 0))} />
          </button>
          {user?.type === 'legal0' ? <AddPassengerInput watchValue={standard} onChange={setStandard} />
            : (
              <p className="m-0">
                {standard}
              </p>
            )}
          <button
            type="button"
            className="bg-transparent border-0 p-0 flex"
          >
            <PlusPassenger
              onClick={() => setStandard(standard + 1)}
            />
          </button>
        </div>
      </div>
      <div className="flex gap-[70px] justify-between items-center">
        <p className="m-0">{trans('child')}</p>
        <div className="flex gap-3 items-center passenger-counter">
          <button
            type="button"
            className="bg-transparent border-0 p-0 flex"
          >
            <PlusPassenger onClick={() => setChild((child - 1 >= 0 ? child - 1 : 0))} />
          </button>
          {user?.type === 'legal0' ? <AddPassengerInput watchValue={child} onChange={setChild} />
            : (
              <p className="m-0">
                {child}
              </p>
            )}
          <button
            type="button"
            className="bg-transparent border-0 p-0 flex"
          >
            <PlusPassenger
              onClick={() => setChild(child + 1)}
            />
          </button>
        </div>
      </div>
      <div className="flex gap-[70px] justify-between items-center">
        <p className="m-0">{trans('disabled_person')}</p>
        <div className="flex gap-3 items-center passenger-counter">
          <button type="button" className="bg-transparent border-0 p-0 flex">
            <PlusPassenger onClick={() => setDisabled((disabled - 1 >= 0 ? disabled - 1 : 0))} />
          </button>
          {user?.type === 'legal0' ? <AddPassengerInput watchValue={disabled} onChange={setDisabled} />
            : (
              <p className="m-0">
                {disabled}
              </p>
            )}
          <button
            type="button"
            className="bg-transparent border-0 p-0 flex"
          >
            <PlusPassenger
              onClick={() => setDisabled(disabled + 1)}
            />
          </button>
        </div>
      </div>
      {closeBtn && (
      <DefaultButton onClick={() => setOpen((prev) => !prev)}>
        {trans('close')}
      </DefaultButton>
      )}
    </div>
  );
}

export default AddPassengersInputContent;
